import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { AppStatusIndicator} from '../components/index'
import { selectAppList } from './reducer'
import { Link } from '../components/index.js'

export class AppStatus extends Component {

    render () {
        let { appList } = this.props
        let appStatusList = null
        if (appList != null) {
            appStatusList = appList.map((app) => {
                return (
                    <div key={app.name}>
                        <span className='access-status-container'>
                            <Link external={true} to={app.url} className='access-status-app link'>{app.name}</Link>
                            <AppStatusIndicator
                                className='access-status-indicator'
                                status={app.available}>
                                {!app.available ? app.error_message : 'App is online and available'}
                            </AppStatusIndicator>
                        </span>
                    </div>
                )
            })
        }

        return (
            <div>
            { appStatusList ? appStatusList : null }
            </div>
        )
    }

    
}

export default withRouter(connect((state) => {
    return {
        appList: selectAppList(state),
    }
}, { })(AppStatus))


// WEBPACK FOOTER //
// ./client/src/appStatus/AppStatus.js